import Vue from 'vue'
import App from './App.vue'
import numFormat from 'vue-filter-number-format';
import VueChartkick from 'vue-chartkick'
import Highcharts from 'highcharts'

Vue.config.productionTip = false
Vue.filter('numFormat', numFormat);
Vue.use(VueChartkick, {adapter: Highcharts})

new Vue({
  render: h => h(App),
}).$mount('#app')
